module.exports = __webpack_public_path__ + "static/media/upload_bg.2da44b04.svg";